import { jsxs, jsx } from 'react/jsx-runtime';

const SvgFormDashSquareOutlined = (props) => jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: [jsx("path", { fill: "#2D2E2E", d: "M3 3v18h18V3H3Zm16 16H5V5h14v14Z" }), jsx("path", { fill: "#2D2E2E", d: "M17 11H7v2h10v-2Z" })] }));

export { SvgFormDashSquareOutlined as default };
//# sourceMappingURL=FormDashSquareOutlined.es.js.map
